var map = {
	"./SidebarLogoBuyPo": 37268,
	"./SidebarLogoBuyPo.tsx": 37268,
	"./SidebarLogoFM": 95012,
	"./SidebarLogoFM.tsx": 95012,
	"./SidebarLogoFinancial": 56978,
	"./SidebarLogoFinancial.tsx": 56978,
	"./SidebarLogoNGAT": 58745,
	"./SidebarLogoNGAT.tsx": 58745,
	"./sidebar_buypo.png": 56507,
	"./sidebar_buypo_old.png": 45217,
	"./sidebar_cattlepo.png": 59352,
	"./sidebar_ccc.png": 66317,
	"./sidebar_financial.png": 51221,
	"./sidebar_financial_new.png": 60902,
	"./sidebar_financial_old.png": 4451,
	"./sidebar_financial_warehousing.png": 21380,
	"./sidebar_fm.png": 89317,
	"./sidebar_fm_new.png": 98870,
	"./sidebar_fm_old.png": 53075,
	"./sidebar_ngat.png": 51032,
	"./sidebar_ngat_new.png": 9343,
	"./sidebar_ngat_old.png": 20774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21275;